export const classes = {
  logo: 'h-[23px] w-auto max-w-[150px] object-contain',
};
